<template>
  <div class="shopCar">
    <div class="shopCarTop">
      <div style="margin-top: 15px" class="shopCarTopSearch">
        <p class="shopCarText">经销商订货单</p>
        <!--        <el-input
          placeholder="请输入内容"
          v-model="goodsName"
          class="input-with-select"
        >
          <el-button slot="append" @click="getShopCarList"> 搜索</el-button>
        </el-input>-->
      </div>
      <p class="shopNum">
        全部商品
        <span>{{ goodsNum }}</span>
      </p>
    </div>
    
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="70"
      class="demo-ruleForm"
    >
      <div class="shopCarTab">
        <div class="shopCarTab_t shopCarTab_t2">
          <p class="checkout">
            <el-checkbox-group
              :indeterminate="isIndeterminate"
              v-model="checkAll"
              @change="handleCheckAllChange"
            ><el-checkbox>全选</el-checkbox>
            </el-checkbox-group>
          </p>
          <p class="name_img">产品图片</p>
          <p class="name">产品名称</p>
          <p class="specifications">规格</p>
          <li class="price">数量</li>
          <li class="jfDate">交付日期</li>
          <li class="facilitator">订货方式</li>
          <p class="operation">操作</p>
        </div>

        <div v-for="(item, index) in ruleForm.shopUserList" :key="index">
          <div class="shopCarTab_t shopCarTab_com">
            <p class="checkout_com">
              <el-checkbox
                  v-model="item.checked"
                  @change="handleCheckedCities2(index,item.checked)"
                ></el-checkbox>
              <span
                style="margin-left: 2%; cursor: pointer"
                @click="goToDetail(item.enterpriseUuid)"
                >{{ item.sellerName }}</span
              >
              <i class="iconfont" @click="startChat(item.sellerUserUuid)"
                >&#xe660;</i
              >
            </p>
          </div>
          <div
            class="shopCarTab_com shopCarTab_comTop"
            v-for="(chilItem, chilIndex) in item.goodsList"
            :key="chilIndex"
          >
            <p class="checkout_mess">
              <el-checkbox-group
                v-model="chilItem.checked"
                @change="handleCheckedCities_child(index,chilIndex,chilItem.checked)"
              >
                <el-checkbox></el-checkbox>
              </el-checkbox-group>
            </p>
            <div class="shopCarTab_t  ">
              <div class="name_img">
                <div style="width: 100%; height: 64px; margin-right: 10px">
                  <img
                    :src="chilItem.imgUrl"
                    alt=""
                    style="width: 100px; height: 64px"
                  />
                </div>
              </div>
              <div
                class="name_mess"
                style="cursor: pointer"
                @click="handGoodsDetails(chilItem.productSpecUuid)"
              >
                <div class="brandBox">
                  <!--              <p class="brand" v-if="chilItem.brand">{{ chilItem.brand }}</p>-->
                  <span>{{ chilItem.productName }}</span>
                </div>
              </div>
              <p class="specifications">{{ chilItem.specName }}</p>
              <div class="price">
                <el-form-item
                  style="width: 134px;margin: 0 auto;"
                  :prop="'shopUserList.' + index + '.goodsList.'+ chilIndex +'.orderNum'"
                  :rules="[
                    { required: true, message: '请填写数量', trigger: 'blur' },
                  ]"
                >
                  <el-input-number
                    style="width: 134px;"
                    v-model="chilItem.orderNum"
                    :min="1"
                  ></el-input-number>
                </el-form-item>
              </div>
              <div class="jfDate">
                <el-form-item
                  :prop="'shopUserList.' + index + '.goodsList.'+ chilIndex +'.deliveryDate'"
                  :rules="[
                    {
                      required: true,
                      message: '请选择交付日期',
                      trigger: 'change',
                    },
                  ]"
                >
                  <el-date-picker
                    v-model="chilItem.deliveryDate"
                    value-format="yyyy-MM-dd"
                    style="width: 140px"
                    type="date"
                    placeholder="选择日期"
                  >
                  </el-date-picker>
                </el-form-item>
              </div>
              <div class="facilitator">
                <el-form-item
                  :prop="'shopUserList.' + index + '.goodsList.'+ chilIndex +'.orderingMethodUuid'"
                  :rules="[
                    {
                      required: true,
                      message: '请选择订货方式',
                      trigger: 'change',
                    },
                  ]"
                >
                  <el-select
                    v-model="chilItem.orderingMethodUuid"
                    filterable
                    placeholder="请选择"
                    style="width: 120px"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.uuid"
                      :label="item.name"
                      :value="item.uuid"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <p class="operation">
                <el-button
                  type="text"
                  @click="deleteGood(chilItem, item.goodsList, chilIndex, index)"
                  >删除</el-button
                >
              </p>
            </div>
            <div class="flex-center other">
              <el-form-item label="需求描述">
                <el-input
                    v-model="chilItem.remark"
                    type="textarea"
                    style="width: 420px; margin-right: 20px"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-upload
                    class="avatar-uploader"
                    action="/service-center/upload/file/single"
                    :file-list="fileList"
                    :limit="5"
                    accept=".jpg,.jpeg,.png,.xlsx , .xls ,.docx,.dox,.pdf, .txt,.pptx , .JPG,.JPEG,.PBG,.GIF,.BMP,.PDF,.XLSX,.XLS ,.DOCX,.DOX ,.TXT , .PPTX"
                    :on-remove="(res,file)=>{
                      return handleRemoveFile(res,file,chilItem);
                    }"
                    :on-error="handleFileError"
                    :on-success="(res,file)=>{
                      return handleFileSuccess(res,file,chilItem);
                    }"
                >
                  <el-button size="small" type="text">上传附件</el-button>
                </el-upload>
              </el-form-item>
            </div>
          </div>
          
        </div>
        <el-empty
          description="暂无数据"
          v-if="ruleForm.shopUserList.length == 0"
           :image-size="100"
        ></el-empty>
      </div>
    </el-form>
    <div class="addressInformation">
      <div class="title">
        <div class="titleLeft">收货信息</div>
      </div>
      <div class="addressList">
        <div
          :class="item.checked ? 'active addressItem' : 'addressItem'"
          v-for="(item, index) in addressList"
          :key="index"
        >
          <el-checkbox
            class="checkBox"
            v-model="item.checked"
            @change="addressChecked(item)"
          ></el-checkbox>
          <div class="name">
            {{ item.receiverName }}
            <el-button
              v-if="item.checked"
              type="text"
              icon="el-icon-edit"
              style="padding: 0; position: relative; z-index: 9"
              @click="toEditAddress(item)"
            ></el-button>
          </div>
          <div class="tel">{{ item.mobile }}</div>
          <div class="address">
            {{ item.province }}{{ item.city }}{{ item.district
            }}{{ item.areaInfo }}
          </div>
          <img
            v-if="item.checked"
            src="@/assets/addressBorder.png"
            class="addressBorder"
          />
        </div>
        <div class="addressItem addItem" @click="toDeliveryAddress">
          <div class="icon"><i class="el-icon-plus"></i></div>
          <div class="addName">新增地址</div>
        </div>
      </div>
    </div>
    <!-- 合计 -->
    <div class="combined" v-if="ruleForm.shopUserList.length != 0">
      <div class="combined_left">
        <p class="checkout">
          <el-checkbox-group
                  :indeterminate="isIndeterminate"
                  v-model="checkAll"
                  @change="handleCheckAllChange"
          ><el-checkbox>全选</el-checkbox>
          </el-checkbox-group>
        </p>
               <p class="combined_left_del" @click="deleteCheckedGood">删除选中的商品</p>
      </div>
      <div class="combined_right">
        <p class="combined_right_ok">已选中 <span>{{ totalNum }}</span> 件产品</p>
               <!-- <p class="combined_right_money">总价：<span>¥{{ totalPrice }}</span></p> -->
        <el-button type="primary" @click="submitOrder('ruleForm')">提交订单</el-button>
      </div>
    </div>
    <!--聊天窗口-->
    <chat-dialog ref="chatDialogRef"></chat-dialog>
    <!--新增/编辑地址-->
    <delivery-address-dialog
      ref="deliveryAddressDialogRef"
      @address="deliveryAddress"
    ></delivery-address-dialog>
  </div>
</template>

<script>
import chatDialog from "../chat/chatDialog";
import {
  getAddressList,
  getUserInfo,
  getDictionaryItem,
  saveShopCarNum,
  getNewcurrent,
  deleteShopCarInfo,
} from "../../utils/interface";
import { mapState, mapMutations } from "vuex";
import { deleteProductCart, getProductCart } from "../../utils/product";
import deliveryAddressDialog from "../print/deliveryAddressDialog.vue";
import {submitProductOrder} from "../../utils/product";
export default {
  //   水泵云商购物车
  name: "shopCar",
  components: { chatDialog, deliveryAddressDialog },
  computed: {
    ...mapState({
      isLogin: "isLogin",
      isUsermessage: "isUsermessage",
    }),
  },
  data() {
    return {
      ruleForm: {
        shopUserList: [],
        receiveAddressUuid: "",
      },
      fileList: [],

      goodsName: "",
      checkAll: false,
      isIndeterminate: true,
      checkChildList: [],
      goodsNum: 0,
      userMessages: {},
      totalPrice: 0,
      totalNum: 0,
      addressList: [],
      options: [],
      rules: {
        receiveAddressUuid: [
          { required: true, message: "请选择收货地址", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getShopCarList();
    this.getAddressList();
    this.getOrderMethod();

    getNewcurrent()
      .then((res) => {
        this.userMessages = res;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  mounted() {
    if (this.isLogin == false) {
      this.$router.push("/productHome");
    }
  },
  methods: {
    ...mapMutations(["isLoginVuex"]),
    getOrderMethod() {
      getDictionaryItem({ groupCode: "ORDERING_METHOD" }).then((res) => {
        this.options = res;
      });
    },
    // 获取地址
    getAddressList() {
      getAddressList().then((res) => {
        res.data.map((item) => {
          if (item.defaultVal == 1) {
            item.checked = true;
            this.ruleForm.receiveAddressUuid = item.uuid;
          } else {
            item.checked = false;
          }
        });
        this.addressList = res.data;
      });
    },
    // 地址选中事件
    addressChecked(val) {
      this.addressList.map((item) => {
        if (item.uuid === val.uuid) {
          item.checked = val.checked;
        } else {
          item.checked = false;
        }
      });
      this.ruleForm.receiveAddressUuid = val.uuid;
    },
    // 新增/修改地址
    deliveryAddress(val) {
      getAddressList().then((res) => {
        res.data.map((item) => {
          if (val.uuid == item.uuid) {
            item.checked = true;
          } else {
            item.checked = false;
          }
        });
        this.addressList = res.data;
      });
    },
    // 模板附件
    handleFileSuccess(res, file,item) {
      item.productOrderFileList.push({url:res.url,name:res.name,uid:file.uid});
    },
    handleRemoveFile(file, fileList,item) {
      item.productOrderFileList = item.productOrderFileList.filter(f => f.uid != file.uid);
    },

    handleFileError(err, file, fileList) {
      this.$message.error(err);
    },
    // 点击打开新增地址弹出框
    toDeliveryAddress() {
      this.$refs.deliveryAddressDialogRef.init("add");
    },
    // 点击打卡编辑地址弹出框
    toEditAddress(item) {
      this.$refs.deliveryAddressDialogRef.init("edit", item);
    },
    handGoodsDetails(uuid) {
      let routeData = this.$router.resolve({
        name: "productDetails",
        query: {
          uuid: uuid,
          typeCode: 'spec',
        },
      });
      window.open(routeData.href);
    },
    startChat(targetUserId) {
      if (this.isLogin) {
        let user = this.$store.state.isUsermessage;
        if (targetUserId == this.userMessages.uuid) {
          this.$message.error(
            "检测当前联系店铺与您处于同一企业，暂不支持联系!"
          );
          return false;
        } else {
          getUserInfo(targetUserId).then((res) => {
            this.$refs.chatDialogRef.init(
              user.uuid,
              user.name,
              user.headUrl,
              targetUserId,
              res.name,
              res.headUrl
            );
          });
        }
      } else {
        this.$message({
          type: "success",
          message: "您需要先登录哦！",
        });
        this.$router.push("/login");
      }
    },
    getShopCarList() {
      this.goodsNum = 0;
      getProductCart().then((res) => {
        if (res.success) {
          res.data.map((item) => {
            item.checked = false;
            item.goodsList.map((childItem) => {
              childItem.checked = false;
              this.goodsNum += 1;
              childItem.orderNum = 1
              childItem.productOrderFileList = []
              childItem.deliveryDate = ""
              childItem.orderingMethodUuid = ""
            });
          });
          
          this.ruleForm.shopUserList = res.data;
          this.getCheckInfo();
          this.handleChange();
        }
      });
    },
    handleCheckAllChange() {
      this.totalNum = 0;
      this.totalPrice = 0;
      this.ruleForm.shopUserList.map((item) => {
        item.checked = this.checkAll;
        item.goodsList.map((childItem) => {
          childItem.checked = this.checkAll;
          if (childItem.checked) {
            this.totalNum++;
          }
        });
      });
      console.log("选择", this.ruleForm.shopUserList)
    },
    handleCheckedCities2(index, val) {
      this.ruleForm.shopUserList[index].goodsList.map((items) => {
        items.checked = val;
      });
      this.handleChange();
      this.getCheckInfo();
    },
    handleCheckedCities_child(index, childIndex, val) {
      this.ruleForm.shopUserList[index].goodsList[childIndex].checked = val;
      this.handleChange();
      this.getCheckInfo();
    },
    // 是否全部选中
    getCheckInfo() {
      let parent_check = 0;
      this.ruleForm.shopUserList.map((item) => {
        let child_check = 0;
        item.goodsList.map((child) => {
          if (child.checked) {
            child_check++;
          }
          if (child_check === item.goodsList.length) {
            item.checked = true;
            parent_check++;
          } else {
            item.checked = false;
          }
        });
      });
      if (parent_check === this.ruleForm.shopUserList.length) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
    handleChange() {
      this.totalNum = 0;
      let count = 0;
      this.ruleForm.shopUserList.map((item) => {
        item.goodsList.map((childItem) => {
          if (childItem.checked) {
            count++;
          }
        });
      });
      this.totalNum = count;
    },
    handleChange1(item) {
      // 保存购物车数量
      saveShopCarNum({ uuid: item.uuid, num: item.num });
      this.handleChange();
    },
    deleteGood(item, goodsList, index, allIndex) {
      // 删除数据
      deleteProductCart(item.cartUuid).then((res) => {
        if (res.success) {
          this.$message.success("删除成功");
          goodsList.splice(index, 1);
            this.totalNum--;
          this.goodsNum -= 1;
          if (goodsList.length == 0) {
            this.ruleForm.shopUserList.splice(allIndex, 1);
          }
          // this.getShopCarList();
        }
      });
    },
    deleteCheckedGood() {
      this.ruleForm.shopUserList.map((item) => {
        console.log(222, item)
        item.goodsList.map((childItem) => {
          if (childItem.checked) {
            deleteProductCart(childItem.cartUuid).then((res) => {
              if (res.success) {
                //this.$message.success("删除成功");
                this.getShopCarList();
              }
            });
          }
        });
      });
    },
    toBuyerCenter(){
      location.href=this.$url.buyerWeb + "/#/providerInquiry";
    },
    submitOrder(formName) {
      if (!this.ruleForm.receiveAddressUuid) {
        this.$message.warning("请选择收货地址!");
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let arr = []
          this.ruleForm.shopUserList.map(item => {
            item.goodsList.map(childItem => {
              if (childItem.checked) {
                arr.push(childItem)
              }
            })
          })
          if(arr.length>0){
            submitProductOrder({
              productList: arr,
              receiveAddressUuid: this.ruleForm.receiveAddressUuid,
            }).then((res) => {
              if (res.success) {
                this.$alert("订货单提交成功，前往买家中心查看", "提示", {
                  confirmButtonText: "确定",
                  callback: this.toBuyerCenter,
                });
              } else {
                this.$message.error("提交失败");
              }
            });
          }else {
                this.$message.error("请选择需要提交的订单");
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
/deep/ .el-form-item {
  display: flex;
}

/deep/ .el-form-item__label {
  flex-shrink: 0;
}
/deep/.el-form-item {
  margin-bottom: 0 !important;
}
.flex-center {
  display: flex;
  align-items: center;
}
.shopCar {
  .addressInformation {
    width: 1200px;
    margin: 0 auto 20px;
    background: #fff;
    border-radius: 2px;

    .title {
      width: 100%;
      height: 47px;
      line-height: 55px;
      border-bottom: 1px solid #f0f0f0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      .titleLeft {
        font-size: 16px;
        font-weight: 500;
        color: #009999;
      }

      .titleRight {
        display: flex;

        button {
          margin-left: 50px;
        }
      }
    }

    .addressList {
      padding: 10px 15px 0;
      display: flex;
      flex-wrap: wrap;

      .addressItem {
        padding: 14px 22px;
        margin-bottom: 24px;
        margin-right: 30px;
        position: relative;
        width: 270px;
        border-radius: 8px;
        border: 2px dashed #e3e3e3;
        font-size: 14px;

        .addressBorder {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
        }

        &.active {
          border: 2px dashed #fff;
        }

        // &:nth-of-type(4n) {
        //   margin-right: 0;
        // }

        .checkBox {
          position: absolute;
          right: 22px;
          top: 14px;
        }

        .name {
          color: #000;
        }

        .tel {
          color: rgba(51, 51, 51, 0.85);
          padding: 6px 0;
        }

        .address {
          color: rgba(51, 51, 51, 0.85);
          line-height: 22px;
        }
      }

      .addItem {
        text-align: center;
        cursor: pointer;
        color: #666;

        &:hover {
          border: 2px dashed #1890ff;
        }

        .icon {
          font-size: 30px;
        }

        .addName {
          font-size: 14px;
          padding-top: 5px;
        }
      }
    }
  }
  .shopCarTop {
    width: 1200px;
    margin: 0 auto;
    .shopCarTopSearch {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .shopCarText {
        flex-shrink: 0;
        font-size: 20px;
        color: #009999;
        font-weight: 600;
      }
      .input-with-select .el-input-group__prepend {
        border: 1px solid #009999;
        background-color: #009999;
      }
      /deep/.el-input-group {
        width: 30%;
      }
      /deep/.el-input__inner {
        height: 33px;
        line-height: 33px;
        border: 1px solid #009999;
      }
      /deep/.el-input-group__append,
      .el-input-group__prepend {
        border: 1px solid #009999;
        background-color: #009999;
      }
      /deep/.el-button {
        color: #fff;
      }
    }
    .shopNum {
      margin: 26px 0 10px;
      color: #009999;
      cursor: pointer;
      font-family: tahoma, arial, Microsoft YaHei, Hiragino Sans GB;
    }
  }
  .shopCarTab {
    width: 1200px;
    margin: 0 auto;
    .other {
      background: #a5e5e536;
      padding: 20px;
    }
    .shopCarTab_t {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding: 10px;
      text-align: center;
      .checkout {
        width: 44px;
      }
      .name {
        width: 200px;
      }
      .name_img {
        width: 250px;
      }
      .name_mess {
        width: 200px;
        text-align: center;
        font-size: 13px;
        img {
          margin-right: 5px;
          width: 100px;
          height: 64px;
        }
      }
      .specifications {
        width: 133px;
        padding: 0 10px;
      }
      .price {
        width: 178px;
        text-align: center;
      }
      .facilitator {
        width: 150px;
        text-align: center;
        display: flex;
        justify-content: center;
      }

      .jfDate {
        width: 200px;
        text-align: center;
        display: flex;
        justify-content: center;
      }
      .money {
        width: 133px;
      }
      .number {
        width: 133px;
      }
      .xiao {
        width: 143px;
      }
      .operation {
        width: 120px;
      }
      .checkout_mess {
        width: 44px;
        text-align: left;
      }
    }
    .shopCarTab_t2 {
      background: #efefef;
    }
    .shopCarTab_com {
      border-bottom: 1px solid #efefef;
      .number {
        /deep/.el-input__inner {
          height: 28px;
          line-height: 28px;
        }
        /deep/.el-input-number__decrease,
        .el-input-number__increase {
          height: 25px;
          line-height: 25px;
          top: 7px;
        }
        /deep/.el-input-number__increase {
          height: 25px;
          line-height: 25px;
          top: 7px;
        }
        /deep/.el-input-number {
          width: 134px;
        }
      }
      .checkout_com {
        width: 25%;
        color: #009999;
        display: flex;
        align-items: center;
        i {
          cursor: pointer;
          font-size: 18px;
          margin-left: 10px;
        }
      }
    }
    .shopCarTab_comTop {
      padding: 15px 0;
      .name_mess {
        span {
          line-height: 22px;
          letter-spacing: 1px;
        }
      }
      .checkout_mess {
        margin-left: 10px;
      }
      .specifications {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .xiao {
        font-weight: 700;
      }
    }
  }
  .combined {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 1200px;
    margin: 30px auto 20px;
    font-size: 14px;
    color: #666;
    margin-top: 0;
    // border: 1px solid #efefef;
    // padding: 20px ;
    .combined_left {
      display: flex;
      align-items: center;
      .combined_left_del {
        margin-left: 15px;
        cursor: pointer;
      }
    }
    .combined_right {
      display: flex;
      align-items: center;
      .combined_right_ok {
        margin-right: 10px;
        i {
          cursor: pointer;
        }
      }
      .combined_right_money {
        margin-right: 15px;
        display: flex;
        align-items: center;
        span {
          font-size: 25px;
          font-weight: 600;
          color: #009999;
        }
      }
      .combined_right_button {
        width: 100px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: #009999;
        color: #fff;
        cursor: pointer;
        font-size: 18px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/specOrderCar.vue